export const ABANDONED_CART_ROOT_PATH = "/abandoned-cart";
/** /abandoned-cart/internal/create-or-update-user */
export const ABANDONED_CART_INTERNAL_ENDPOINT_SUFFIX = "/internal/create-or-update-user";
export const ABANDONED_CART_INTERNAL_ENDPOINT_PATH = `${
  ABANDONED_CART_ROOT_PATH
}${
  ABANDONED_CART_INTERNAL_ENDPOINT_SUFFIX
}`;

export const ABANDONED_CART_BREEDER_ENDPOINT_SUFFIX = "/breeder/create-or-update-user";
/** /abandoned-cart/breeder/create-or-update-user */
export const ABANDONED_CART_BREEDER_ENDPOINT_PATH = `${
  ABANDONED_CART_ROOT_PATH
}${
  ABANDONED_CART_BREEDER_ENDPOINT_SUFFIX
}`;

export const ABANDONED_CART_PUBLIC_ENDPOINT_SUFFIX = "/create-or-update-user";
/** /abandoned-cart/create-or-update-user */
export const ABANDONED_CART_PUBLIC_ENDPOINT_PATH = `${
  ABANDONED_CART_ROOT_PATH
}${
  ABANDONED_CART_PUBLIC_ENDPOINT_SUFFIX
}`;

export const SHREDDED_AB_TEST_ASSIGNMENT_ENDPOINT_SUFFIX = "/internal/shredded-ab-test-assignment";
/** /abandoned-cart/internal/shredded-ab-test-assignment */
export const SHREDDED_AB_TEST_ASSIGNMENT_ENDPOINT_PATH = `${
  ABANDONED_CART_ROOT_PATH
}${
  SHREDDED_AB_TEST_ASSIGNMENT_ENDPOINT_SUFFIX
}`;
